export default __webpack_public_path__ + "static/media/logoHome3.d985938d.png";